"use strict";
exports.__esModule = true;
var createLabels = function (frequency, from, to) {
    if (frequency === 'DAILY') {
        return Array.from(new Array(to.diff(from, 'days').plus({ days: 1 }).days)).map(function (_, index) {
            return from.plus({ days: index }).toFormat('yyyy/MM/dd');
        });
    }
    else if (frequency === 'WEEKLY') {
        return Array.from(new Array(Math.ceil(to.diff(from, 'weeks').plus({ days: 1 }).weeks))).map(function (_, index) {
            return from.plus({ weeks: index }).toFormat('yyyy/MM/dd~');
        });
    }
    else {
        return Array.from(new Array(Math.ceil(to.diff(from, 'months').plus({ days: 1 }).months))).map(function (_, index) {
            return from.plus({ months: index }).toFormat('yyyy/MM');
        });
    }
};
exports["default"] = createLabels;
